module.exports = __webpack_public_path__ + "img/card-smoking.5fa7d2b0.png";